import { useUnit } from 'effector-react';
import { forwardRef } from 'react';
import { Row, RegistryModel } from 'shared/lib';
import { Empty, EmptyProps } from '../empty';

export const createRegistryEmpty = <
	TRow extends Row,
	TFilters extends Record<string, unknown>,
	TError,
>(
	model: RegistryModel<TRow, TFilters, TError>,
) => {
	const RegistryEmpty = forwardRef<HTMLDivElement, EmptyProps>((props, ref) => {
		const empty = useUnit(model.$empty);

		return (
			empty && (
				<Empty
					ref={ref}
					{...props}
				/>
			)
		);
	});

	return RegistryEmpty;
};
